import CASL from '@/utils/constants/casl'

export default {
  path: 'serial-number',
  children: [
    {
      path: '',
      name: 'serial-number.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.SERIAL_NUMBER
      },
      component: () => import('./list/SerialNumberListPage.vue')
    }
  ]
}
